// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@steiner/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { accountSummaryFiltersStyles } from "@steiner/App/Widgets/AccountSummary/AccountSummaryFilter";
import { css } from "styled-components";

accountSummaryFiltersStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

accountSummaryFiltersStyles.buttonsItem = {
    width: [12, 12, 12, 9, 9],
    css: css`
        &&& {
            margin-left: auto;
            justify-content: flex-end;
            align-items: flex-end;
        }
    `,
};

accountSummaryFiltersStyles.shipToGridItem = {
    width: [12, 12, 6, 2, 2],
};

accountSummaryFiltersStyles.yearGridItem = {
    width: [12, 12, 6, 2, 2],
};

accountSummaryFiltersStyles.monthGridItem = {
    width: [12, 12, 6, 2, 2],
};

accountSummaryFiltersStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};
